// extracted by mini-css-extract-plugin
export default {"root":"shared-module__root--vocex","fontSmoothing":"shared-module__fontSmoothing--cAKfP","SubNav__spacer":"shared-module__SubNav__spacer--daM_8"};